module.exports = __webpack_public_path__ + "img/produtividade.05dec965.svg";